/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { AnnounceLib, AnnounceLibInterface } from "../AnnounceLib";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderId",
        type: "bytes32",
      },
    ],
    name: "OrderAnnounce",
    type: "event",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220fd2f3a0ecbcca7149dda122a8b1d550287e9c06da758463a22072f8aa9bbab3464736f6c63430008090033";

type AnnounceLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AnnounceLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AnnounceLib__factory extends ContractFactory {
  constructor(...args: AnnounceLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AnnounceLib> {
    return super.deploy(overrides || {}) as Promise<AnnounceLib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): AnnounceLib {
    return super.attach(address) as AnnounceLib;
  }
  connect(signer: Signer): AnnounceLib__factory {
    return super.connect(signer) as AnnounceLib__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AnnounceLibInterface {
    return new utils.Interface(_abi) as AnnounceLibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AnnounceLib {
    return new Contract(address, _abi, signerOrProvider) as AnnounceLib;
  }
}
